import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    PopUpStatus: "false",
    dangerMessage: null,
    dangerVarible: null,
    axiosProps: null,
    redirectUrl: null
}
const popUpSlice = createSlice({
    name: "popup",
    initialState,
    reducers: {
        SetPopUpActive: (state, action) => {
            state.PopUpStatus = "true"
            state.dangerMessage = action.payload.dangerMessage
            state.dangerVarible = action.payload.dangerVarible
            state.redirectUrl = action.payload.redirectUrl
            state.axiosProps = action.payload.axiosProps

        },
        PopUpStatuDeactive: (state) => {
            state.PopUpStatus = "false"
        }
    }
})
export const { PopUpStatuDeactive, SetPopUpActive } = popUpSlice.actions
export default popUpSlice;